import { Briefcase, ChevronRight } from "lucide-react";

const experiences = [
  {
    title: "Cybersecurity Specialist",
    type: "Current Role",
    description:
      "Expertise in phishing, vulnerability scanning, penetration testing, security assessments, threat intelligence, forensics, physical security assessments, and red team operations.",
    highlights: [
      "Red Team Operations",
      "Penetration Testing",
      "Security Assessments",
      "Threat Intelligence",
    ],
  },
  {
    title: "IT Consultant",
    type: "Previous Role",
    description:
      "Experience with test automation, managing DevSecOps pipelines, bug tracing, Kubernetes, Docker, and Azure infrastructure.",
    highlights: ["DevSecOps", "Kubernetes", "Docker", "Azure"],
  },
  {
    title: "Test Automation Engineer",
    type: "Previous Role",
    description:
      "Proficient in Selenium, Katalon, API testing, and quality assurance practices.",
    highlights: ["Selenium", "API Testing", "QA Automation"],
  },
  {
    title: "DevOps Developer",
    type: "Bachelor's Thesis",
    description:
      "Built an API to maintain the quality of Azure ARM-scripts, integrated with DevOps pipelines.",
    highlights: ["Azure ARM", "API Development", "DevOps"],
  },
  {
    title: "Operation Technician",
    type: "Entry Level",
    description:
      "Incident response for a Network Operations Center, including monitoring, troubleshooting, network maintenance, and crisis management.",
    highlights: ["NOC", "Incident Response", "Network Monitoring"],
  },
];

const Experience = () => {
  return (
    <section id="experience" className="py-24 relative bg-card/30">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="font-mono text-sm text-primary mb-4">
            {">"} cat /var/log/career.log
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Career <span className="text-primary text-glow">Timeline</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            From network operations to offensive security - a journey through
            the layers of cybersecurity.
          </p>
        </div>

        {/* Timeline */}
        <div className="max-w-4xl mx-auto relative">
          {/* Vertical line */}
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 custom-vertical-line w-px bg-gradient-to-b from-primary via-primary/50 to-transparent md:-translate-x-1/2" />

          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <div
                key={exp.title}
                className={`relative flex flex-col md:flex-row gap-8 ${
                  index % 2 === 0 ? "md:flex-row-reverse" : ""
                }`}
              >
                {/* Timeline node */}
                <div className="absolute left-0 md:left-1/2 w-4 h-4 bg-primary rounded-full glow md:-translate-x-1/2 z-10" />

                {/* Content */}
                <div
                  className={`flex-1 ml-8 md:ml-0 ${
                    index % 2 === 0 ? "md:pr-12" : "md:pl-12"
                  }`}
                >
                  <div className="cyber-card p-6 hover-lift">
                    <div className="flex items-center gap-3 mb-3">
                      <Briefcase className="w-5 h-5 text-primary" />
                      <span className="text-xs font-mono text-primary bg-primary/10 px-2 py-1 rounded">
                        {exp.type}
                      </span>
                    </div>

                    <h3 className="text-xl font-bold mb-3">{exp.title}</h3>
                    <p className="text-muted-foreground mb-4 text-sm leading-relaxed">
                      {exp.description}
                    </p>

                    <div className="flex flex-wrap gap-2">
                      {exp.highlights.map((highlight) => (
                        <span
                          key={highlight}
                          className="flex items-center gap-1 text-xs font-mono text-foreground/80 bg-muted px-2 py-1 rounded"
                        >
                          <ChevronRight className="w-3 h-3 text-primary" />
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="hidden md:block flex-1" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
